import { normalizeString } from './normalize-string';

export interface WrapWithHTMLTagOptions {
  tag?: string;
  className?: string;
}

export function wrapWithHTMLTag(target: string, partToWrap: string, { tag = 'span', className = '' }: WrapWithHTMLTagOptions = {}): string {
  const normalizedTarget = normalizeString(target);
  const normalizedPartToWrap = normalizeString(partToWrap);
  const matchIndex = normalizedTarget.indexOf(normalizedPartToWrap);
  if (matchIndex !== -1) {
    const endMatchIndex = matchIndex + normalizedPartToWrap.length;
    const classAttribute = className && ` class="${ className }"`;
    return target.slice(0, matchIndex)
      + `<${ tag }${ classAttribute }>` + target.slice(matchIndex, endMatchIndex) + `</${ tag }>`
      + target.slice(endMatchIndex);
  }
  return target;
}
